module.exports = __webpack_public_path__ + "static/media/ci_white_edit.654c4945.svg";